
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"outlet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outletId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderingServiceEnum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderingServiceEnum"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outletId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryFee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimumBasket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderingServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderingServiceEnum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderingServiceEnum"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderingServiceEnum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acceptsAsapOrders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acceptsPreOrders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acceptsSameDayPreOrders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimumLeadTimeInMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumDaysInAdvance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slotLengthInMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endTime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"paymentMethodEnum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"orderingServiceSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preparationMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimatedCompletionMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operationStatus"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":783}};
    doc.loc.source = {"body":"query outlet($outletId: String!, $orderingServiceEnum: OrderingServiceEnum!) {\n  outlet(id: $outletId) {\n    id\n    url\n    deliveryFee\n    minimumBasket\n    orderingServices(orderingServiceEnum: $orderingServiceEnum) {\n      id\n      name\n      state\n      slug\n      orderingServiceEnum\n      acceptsAsapOrders\n      acceptsPreOrders\n      acceptsSameDayPreOrders\n      minimumLeadTimeInMinutes\n      maximumDaysInAdvance\n      slotLengthInMinutes\n      openingHours {\n        id\n        dayOfWeek\n        startTime\n        endTime\n      }\n      paymentMethods {\n        id\n        name: paymentMethodEnum\n        isEnabled\n      }\n      orderingServiceSettings {\n        id\n        preparationMinutes\n        estimatedCompletionMinutes\n        operationStatus\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["outlet"] = oneQuery(doc, "outlet");
        
